export default __webpack_public_path__ + "static/media/fun_aug2020_pt3.c53559c0.bmp";